var producttype = '';
var fullproducttype = '';
var leathercolor = '';
var feltcolor = '';
var option0 = '';

var totalimages = '';
var selectedimage = {};

var amountOptions = '';

var products = {};

$(document).ready(function (){
    
    if( $(".item_pictures").length > 0 ){
        products.showimage(1, false);
    }
    
    $(".image_thumbs").live("click",function(){
        var imagename = $(this).attr("id");
    	imagename = imagename.split('_')[2];
		products.showimage( imagename, true );
	});
    
    $("#addToCart").live("click",function(){
        Shopify.Customizr.attach();
		var form = $(this).parents('form:first');
		$( form ).submit();
	});
    
    $(".single-option-selector").live("change",function(){
        set_colors();
        var num = find_element_by_color(feltcolor, leathercolor);
        products.showimage( num, false );
    });
});

products.showimage = function( imagenumber,changeselect,first ){
    $(".image_thumbs").removeClass("activeThumb");
    $(".item_pictures").hide();
    var image = '#item_pictures_'+imagenumber;
    var thumb = '#image_thumbs_'+imagenumber;
    
    if( changeselect == true ){
        var bgurl = $( image ).css("background-image").split("/");
    	var item_ = bgurl[ bgurl.length - 1 ].split(".");
		selectedimage = item_[0].split("_");
        selectColors( selectedimage[1],selectedimage[2],imagenumber );
    }
    
    $(image).show();
    $(thumb).addClass("activeThumb");
}

set_colors = function(){
    if(amountOptions == 3){
        leathercolor = $("#product-select-option-1").val();
        feltcolor = $("#product-select-option-2").val();
    }else{
        leathercolor = $("#product-select-option-0").val();
        feltcolor = $("#product-select-option-1").val();        
    }  
}

selectColors = function (lcolor,fcolor,imagenumber){
    fcolor = fcolor.capitalize();
	lcolor = lcolor.capitalize();
    
    if(amountOptions == 3){
        $("#product-select-option-1").val(lcolor );
        selectFeltColor("#product-select-option-2",fcolor,lcolor,imagenumber);
    }else{
        $("#product-select-option-0").val(lcolor );
        selectFeltColor("#product-select-option-1",fcolor,lcolor,imagenumber);
    }
    //selectCallback();
    //Shopify.linkOptionSelectors({{ product | json }});
    //Shopify.linkOptionSelectors({{ product | json }});
}

selectFeltColor = function( id, fcolor,lcolor,imagenumber ){
    products.showimage( imagenumber, false );
    Shopify.updateOptionsInSelector(1);
    $(id).val( fcolor );
    Shopify.updateOptionsInSelector(1);
}

find_element_by_color = function ( feltcolor, leathercolor ) {
    var items = $(".item_pictures");
	var leathercolor	= leathercolor;
	var feltcolor	= feltcolor;

	for( var i = 0; i < items.length; i++ ) {
		var image	= $(items[i]).css( 'background-image' );
		var regexp	= new RegExp( "\/[0-9,a-z]+_"+leathercolor+"_"+feltcolor, "i" );
		if( image.match( regexp ) ) {
			return $(items[i]).attr('id').split('_')[2];
		}
	}
	return false;
};

//$("#outofstock_msg").delay(1000).slideDown('fast');
outofColorCheck = function(){
    console.log( leathercolor );
    console.log( feltcolor );
    console.log( option0 );
}

// (c) Copyright 2011 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See http://wiki.shopify.com/Linked_Options
Shopify.optionsMap = {};
Shopify.updateOptionsInSelector = function(selectorIndex) {
  var key = jQuery('.single-option-selector:eq(0)').val();
  if (selectorIndex === 2) {
    key += ' / ' + jQuery('.single-option-selector:eq(1)').val();
  }
  var selector = jQuery('.single-option-selector:eq(' + selectorIndex + ')');
  var initialValue = selector.val();
  selector.empty();    
  var availableOptions = Shopify.optionsMap[key];
  for (var i=0; i<availableOptions.length; i++) {
    var option = availableOptions[i];
    var newOption = jQuery("<option></option>").val(option).html(option);
    selector.append(newOption);
  }
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  selector.trigger('change');
  amountOptions = $(".selector-wrapper").length;
  set_colors();
};
Shopify.linkOptionSelectors = function(product) {
  // If we have only one option, we have nothing to do.
  if (product.options.length === 1) return;
  // Building our mapping object.
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    // removed the loop to check if an item was in stock (to make pre-orders possible)
    var key = variant.option1;
    Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
    Shopify.optionsMap[key].push(variant.option2);
    Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
    if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
    }
  }
  
 // console.log( Shopify.optionsMap );
  
  //if( preOrderItem == true){
  //}else{

  // Update options right away.
  Shopify.updateOptionsInSelector(1);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
  // When there is an update in the first dropdown.
  jQuery(".single-option-selector:eq(0)").change(function() {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
  // When there is an update in the second dropdown.
  jQuery(".single-option-selector:eq(1)").change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
};